module.exports = __webpack_public_path__ + "static/media/bpbg-2022-6.7b55f237.gif";